import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { InstitucionService } from './institucion.service';

@NgModule({
    declarations: [],
    imports: [
      CommonModule,
      HttpClientModule,
    ],
    providers: [InstitucionService],
    exports: []
  })
  export class InstitucionModule { }